import { render, staticRenderFns } from "./ApiResources.vue?vue&type=template&id=38048884&"
import script from "./ApiResources.vue?vue&type=script&lang=js&"
export * from "./ApiResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports